export const button = () => ({
    width: '1.5625rem',
    height: '2.5rem',
    padding: '0',

    desktop: {
        display: 'none',
    },
});
